import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { IStoreState } from "../../reducers/types";
import {
  getHotelShopSelectedLodging,
  getHotelShopShopRequestId,
  getViewedHotelDetailsProperties,
  getViewedHotelDetailsTrackingProps,
  isAddOnOptionAvailableSelector,
  getHotelShopRoomInfoProducts,
  getHotelShopRoomInfoProductsWithTransformedIndexes,
  getRefundableRoomProductWithSelectedCfarId,
  getHotelCfarOfferChoicePropertiesSelector,
  getHotelShopCallState,
  getRefundableRoomProductCorrespondingToChosenRoom,
  getHotelShopDateRange,
} from "./reducer/selectors";
import { HotelShop } from "./component";
import { actions } from "./actions";
import { getRewardsAccounts } from "../rewards/reducer";
import { actions as rewardsActions } from "../rewards/actions";
import {
  fetchTravelWalletCreditHistory,
  fetchTravelWalletDetails,
} from "../travel-wallet/actions/actions";
import {
  fetchCfarQuotes,
  setHasSelectedRefundableRoom,
  setSelectedCfarId,
  setHasAddedCfarFromModal,
} from "../ancillary/actions/actions";
import {
  hasSelectedRefundableRoomSelector,
  isHotelCfarRefundDisplayShowAmountEnabledSelector,
  isHotelCfarRefundDisplayShowAmountAdditionalPlacesEnabledSelector,
  isFintechHotelUpdatedUxEnabledSelector,
  isHotelCfarRefundDisplayNonRefPartialEnabledSelector,
} from "../ancillary/reducer";
import { getFromDate, getUntilDate } from "../search/reducer";
import { getHotelAvailabilityRoomsCount } from "../availability/reducer";
import {
  setSelectedLodgingIsFavorited,
  setSelectedRoomId,
} from "./actions/actions";
import {
  listPaymentMethods,
} from "../availability/actions/actions";

const mapStateToProps = (state: IStoreState) => ({
  fromDate: getFromDate(state),
  untilDate: getUntilDate(state),
  hotelShopCallState: getHotelShopCallState(state),
  selectedLodging: getHotelShopSelectedLodging(state),
  rewardsAccounts: getRewardsAccounts(state),
  viewedHotelDetailsProperties: getViewedHotelDetailsProperties(state),
  trackingProps: getViewedHotelDetailsTrackingProps(state),
  hotelShopShopRequestId: getHotelShopShopRequestId(state),
  isAddOnOptionAvailable: isAddOnOptionAvailableSelector(state),
  roomInfoProducts: getHotelShopRoomInfoProducts(state),
  roomInfoProductsWithTransformedIndexes:
    getHotelShopRoomInfoProductsWithTransformedIndexes(state),
  hasSelectedRefundableRoom: hasSelectedRefundableRoomSelector(state),
  refundableRoomProductWithSelectedCfarId:
    getRefundableRoomProductWithSelectedCfarId(state),
  refundableRoomProductCorrespondingToChosenRoom:
    getRefundableRoomProductCorrespondingToChosenRoom(state),
  getHotelCfarOfferChoiceProperties:
    getHotelCfarOfferChoicePropertiesSelector(state),
  isHotelCfarRefundDisplayShowAmount:
    isHotelCfarRefundDisplayShowAmountEnabledSelector(state),
  isHotelCfarRefundDisplayShowAmountAdditionalPlaces:
    isHotelCfarRefundDisplayShowAmountAdditionalPlacesEnabledSelector(state),
  searchedRoomsCount: getHotelAvailabilityRoomsCount(state),
  isFintechHotelUpdatedUxEnabled: isFintechHotelUpdatedUxEnabledSelector(state),
  isHotelCfarRefundDisplayNonRefPartialEnabled:
    isHotelCfarRefundDisplayNonRefPartialEnabledSelector(state),
  hotelShopDateRange: getHotelShopDateRange(state),
});

export const mapDispatchToProps = {
  fetchHotelShop: actions.fetchHotelShop,
  selectLodging: actions.selectLodging,
  resetLodging: actions.resetLodging,
  selectRoomType: actions.selectRoomType,
  setSelectedAccount: rewardsActions.setSelectedAccountReferenceId,
  fetchTravelWalletDetails,
  fetchCfarQuotes,
  setHasSelectedRefundableRoom,
  setSelectedCfarId,
  fetchTravelWalletCreditHistory,
  setSelectedRoomId,
  setHasAddedCfarFromModal,
  listPaymentMethods,
  setSelectedLodgingIsFavorited,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type HotelShopConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedHotelShop = withRouter(connector(HotelShop));
